import { Box, Typography } from "@mui/material";
import React from "react";
import { Questions } from "../components/academic/Questions";

export const Quiz = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        className="row"
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6">Time Remaining: 20 m 15 s</Typography>
        <Typography variant="h6">Quiz 1</Typography>
        <Typography variant="h6">Total marks: 30</Typography>
      </Box>
      <Questions />
    </Box>
  );
};
